import { propertyValuesNormalizer } from '../normalizers/propertyValuesNormalizer'
import { propertyValuesRelationNormalizer } from '../normalizers/propertyValuesRelationNormalizer'
import { Element } from '../../composition-functions'
import { ymEventAdapter } from "./ymEventAdapter";

export const buttonsAdapter = (buttonsAction: Element[] | undefined | null) => {
  // Возвращаем пустой массив если нет данных
  if (!buttonsAction) return []

  return buttonsAction.map((button) => {
    const { id, name, propertyValues = [], propertyValuesEnum = [], propertyValuesRelation = [] } = button
    const properties = propertyValuesNormalizer([
      ...(propertyValues || []),
      ...(propertyValuesEnum || []),
    ])
    const ymEventList = propertyValuesRelationNormalizer(propertyValuesRelation)['ymEvent']
    const propertyRelations = propertyValuesRelationNormalizer(propertyValuesRelation)

    return {
      id,
      name: name || undefined,
      ...properties,
      ...propertyRelations,
      ymEvent: ymEventList?.length ? ymEventAdapter(ymEventList[0]) : null,
      arrow: properties.arrow === 'Да',
      openInNewTab: properties.openInNewTab === 'Да',
      padding: properties.padding ? properties.padding === 'Да' : true,
      svgIcon: hardcodedButtonIconsMap[properties.svgIconId] || '',
    }
  })
}

const hardcodedButtonIconsMap = {
  'menu-header-menu': 'menu-header-menu',
  'menu-header-dms': 'menu-heart',
  'menu-header-login': 'menu-person'
}
